import styled from 'styled-components';

interface Props {
  open: boolean;
}

export const Container = styled.nav<Props>`
  width: ${props => (props.open ? '16rem' : '5rem')};
  height: 100%;

  background-color: ${props => (props.open ? 'white' : 'transparent')};
  transition: width 200ms ease, background-color 200ms ease;
  box-shadow: 2px 0 12px rgba(116, 76, 180, 0.15);
  border-right: 1px solid rgba(116, 76, 180, 0.1);
  top: 0;
`;

export const NavContainer = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 12px;
  gap: 8px;
`;




